import { AugmentationPanelLegacyForm } from "@pathwright/ux/src/components/augmentation/AugmentationPanelLegacyForm"
import { useHistory } from "react-router-dom"
import { MentorGroupForm } from "../groups/add/AddMentorGroupCard"

function GroupAddAugmentation({
  parentGroupId
}: {
  parentGroupId?: number | null
}) {
  const history = useHistory()

  return (
    <AugmentationPanelLegacyForm cardFieldPadding>
      <MentorGroupForm parentGroupId={parentGroupId} onSave={history.goBack} />
    </AugmentationPanelLegacyForm>
  )
}

export default GroupAddAugmentation
